import { fetch } from '@utils/utils';
import * as T from '@modules/hr-workDayTypes/_workDayTypesTypes';

export const getWorkDayType = ({ addError }) => async (id: string): Promise<T.WorkDayType> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/evidence/types/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.WorkDayType = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/hr-workDayTypes/_workDayTypesActions.ts